import { Field } from "./ui";

export type Seo = { title?: string; description?: string };

// Titlul și descrierea pentru motoarele de căutare, cu previzualizarea rezultatului din Google.
// Goale = magazinul folosește titlul/numele și începutul descrierii.
export default function SeoFields({ value, onChange, fallbackTitle, fallbackDescription, path }: {
  value: Seo; onChange: (v: Seo) => void; fallbackTitle: string; fallbackDescription: string; path: string;
}) {
  const title = value.title || fallbackTitle;
  const desc = value.description || fallbackDescription;
  const count = (s: string | undefined, rec: number) => {
    const n = (s ?? "").length;
    return <span className={n > rec ? "text-amber-600" : ""}>{n}/{rec} caractere recomandate</span>;
  };
  return (
    <div className="space-y-4">
      <Field label="Titlu SEO" hint={undefined}>
        <input className="input" maxLength={120} placeholder={fallbackTitle} value={value.title ?? ""} onChange={(e) => onChange({ ...value, title: e.target.value })} />
        <span className="mt-1 block text-xs text-slate-400">{count(value.title, 60)}</span>
      </Field>
      <Field label="Descriere SEO">
        <textarea className="input min-h-20" maxLength={320} placeholder={fallbackDescription} value={value.description ?? ""}
          onChange={(e) => onChange({ ...value, description: e.target.value })} />
        <span className="mt-1 block text-xs text-slate-400">{count(value.description, 160)}</span>
      </Field>
      <div className="rounded-lg border border-slate-200 bg-white p-3">
        <div className="mb-1 text-[11px] font-semibold uppercase tracking-wide text-slate-400">Previzualizare în Google</div>
        <div className="truncate text-xs text-slate-500">{path}</div>
        <div className="truncate text-lg leading-snug text-[#1a0dab]">{title.length > 60 ? title.slice(0, 59) + "…" : title}</div>
        <div className="line-clamp-2 text-sm text-slate-600">{desc.length > 160 ? desc.slice(0, 159) + "…" : desc}</div>
      </div>
    </div>
  );
}

// Începutul descrierii, ca text simplu (aceeași regulă ca în magazin).
export function plain(s: string, max = 160) {
  const t = s.replace(/<[^>]+>/g, " ").replace(/[#*_`>[\]]/g, "").replace(/\s+/g, " ").trim();
  return t.length <= max ? t : t.slice(0, max - 1) + "…";
}
